/** The dashboard's name, as people see it. */
export const APP_NAME = "De Ceuster MCP";

/** The frontend's version: package.json's, fixed into the bundle at build time (vite.config.ts). */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION;
